import { render, staticRenderFns } from "./ActivateWeldingInspector.vue?vue&type=template&id=3d00c2e6"
import script from "./ActivateWeldingInspector.vue?vue&type=script&lang=js"
export * from "./ActivateWeldingInspector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports